/***
 * @Description:
 * @Author: 凯欣
 * @Date: 2022-09-14 18:09:17
 * @LastEditTime: 2022-12-06 17:40:19
 * @LastEditors: 凯欣
 * @FilePath: \yongdian-pc\src\http\config\index.js
 * @kaixin
 */
/*
 * @Description:
 * @Author: 凯欣
 * @Github:
 * @Date: 2022-09-14 18:09:17
 * @LastEditTime: 2022-10-31 14:13:05
 * @FilePath: \yongdian-pc\src\http\config\index.js
 */
const serverConfig = {
  // baseURL: 'https://443137d27m.zicp.fun',
  // baseURL: 'http://101.42.169.117/prod-api',
  // baseURL: "http://www.ferson.cn/prod-api",
  // baseURL: 'https://www.wuyouyongdian.com/prod-api',
  baseURL: "https://www.wuyouyd.com/prod-api",
  // baseURL: "http://10.122.100.151:18080",
  // baseURL: "http://127.0.0.1:18080",
  // baseURL: "http://10.122.100.107:18080",
  useTokenAuthorization: true,
  api: "/api/",
};
export default serverConfig;
